<template>
  <router-link :to="to" class="sc" :style="{ '--i': index }">
    <span class="sc__tile">
      <AppIcon :name="icon" :size="26" :stroke="1.9" />
    </span>
    <span class="sc__body">
      <span v-if="loading" class="sc__skeleton ecu-skeleton" aria-hidden="true"></span>
      <strong v-else class="sc__value">{{ value }}</strong>
      <span class="sc__label">{{ label }}</span>
    </span>
    <span class="sc__go" aria-hidden="true">
      <AppIcon name="chevron-right" :size="15" :stroke="2.4" />
    </span>
  </router-link>
</template>

<script>
import AppIcon from "./AppIcon.vue";

// Dashboard counter tile: icon, number, label and an arrow. The whole tile is the link.
export default {
  name: "StatCard",
  components: { AppIcon },
  props: {
    icon: { type: String, required: true },
    label: { type: String, required: true },
    value: { type: [Number, String], default: 0 },
    to: { type: [String, Object], required: true },
    loading: { type: Boolean, default: false },
    index: { type: Number, default: 0 },
  },
};
</script>

<style scoped>
.sc {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  min-height: 92px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid rgba(11, 31, 75, 0.1);
  box-shadow: 0 8px 26px rgba(20, 40, 90, 0.1);
  color: var(--ecu-navy, #0b1f4b);
  text-decoration: none;
  animation: sc-rise 0.45s ease both;
  animation-delay: calc(var(--i, 0) * 45ms);
  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
}
.sc[data-v-1ed5b12e]:hover {
    color: var(--ecu-navy, #0b1f4b);
    transform: translateY(-3px);
    background: #fff7ef;
    border-color: rgb(232 77 0 / 32%);
    box-shadow: 0 14px 34px rgb(242 97 15 / 0%);
}
.sc:focus-visible {
  outline: 2px solid var(--ecu-orange, #f97316);
  outline-offset: 2px;
}
.sc__tile {
  width: 58px;
  height: 58px;
  flex-shrink: 0;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffd9bd;
  color: #e04e00;
  transition: background 0.22s ease, color 0.22s ease;
}
.sc:hover .sc__tile {
  background: linear-gradient(135deg, #ff7a1a, #e84d00);
  color: #fff;
}
.sc__body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.sc__value {
  font-size: var(--ecu-fs-h1);
  line-height: 1.15;
  font-weight: var(--ecu-fw-heading);
  color: #0b1f4b;
  letter-spacing: -0.01em;
}
.sc__skeleton {
  display: block;
  width: 42px;
  height: 24px;
  margin-bottom: 2px;
}
.sc__label {
  font-size: var(--ecu-fs-body);
  line-height: 1.3;
  font-weight: 600;
  color: #2f3b5c;
}
.sc__go {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffd9bd;
  color: #e04e00;
  transition: background 0.22s ease, color 0.22s ease, transform 0.22s ease;
}
.sc:hover .sc__go {
  background: #e84d00;
  color: #fff;
  transform: translateX(2px);
}
@keyframes sc-rise {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: none; }
}
@media (prefers-reduced-motion: reduce) {
  .sc { animation: none; transition: none; }
}
</style>